import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../../../components/buttons/buttons";
import { DeleteCardModal } from "../../../../../components/modals/deleteCardModal";
import { getMyPaymentInstruments } from "../../../../../redux/paymentInstrument/paymentInstrumentActions";
import { AddNewCardModal } from "../../../../../components/modals/addNewCardModal";

export default function UserCards() {
  const dispatch = useDispatch();
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [selectedCardId, setSelectedCardId] = useState(null);
  const { myPaymentInstruments } = useSelector(
    (state) => state.paymentInstrument
  );

  const [isOpen, setIsOpen] = useState(false);
  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  function closeDeleteModal() {
    setDeleteModalVisible(false);
    setSelectedCardId(null);
  }

  function openDeleteModal(cardId) {
    setSelectedCardId(cardId);
    setDeleteModalVisible(true);
  }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        dispatch(getMyPaymentInstruments());
    }, [dispatch]);

    return (
      <>
        <div className="w-full">
          <AddNewCardModal show={isOpen} onClose={closeModal} />
          <div>
            {myPaymentInstruments?.data?.length > 0 ? (
              <div className="overflow-x-auto py-6">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50 dark:bg-gray-800">
                    <tr>
                      <th className="py-3 px-6 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                        S/N
                      </th>
                      <th className="py-3 px-6 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                        Card Number
                      </th>
                      <th className="py-3 px-4 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                        Expiry Date
                      </th>
                      <th className="py-3 px-4 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                        CVV
                      </th>
                      <th className="py-3 px-4 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider"></th>
                    </tr>
                  </thead>
                  <tbody className="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700">
                    {myPaymentInstruments?.data?.map((card, key) => (
                      <tr
                        className="hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
                        key={key}
                      >
                        <td className="py-4 px-6 whitespace-nowrap text-sm sm:text-base text-gray-900 dark:text-white">
                          {key + 1 || "--"}
                        </td>
                        <td className="py-4 px-6 whitespace-nowrap text-sm sm:text-base text-gray-900 dark:text-white">
                          {card?.details?.card_number || "--"}
                        </td>
                        <td className="py-4 px-4 whitespace-nowrap text-sm sm:text-base text-gray-700 dark:text-gray-300">
                          {card?.details?.expiration_date || "--"}
                        </td>
                        <td className="py-4 px-4 whitespace-nowrap text-sm sm:text-base text-gray-700 dark:text-gray-300">
                          {card?.details?.cvv || "--"}
                        </td>
                        <td className="py-4 px-4 whitespace-nowrap">
                          <Button.Secondary
                            title={"Delete"}
                            onClick={() => openDeleteModal(card?.id)}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="my-10 mt-20 text-center">
                {/* <img
                                src={Empty}
                                alt="empty state"
                                className="flex justify-center mx-auto mb-4"
                            /> */}
                <p className="font-bold mb-2">No Cards</p>
                <p className="text-sm text-gray-400">
                  Your Card list shows here.
                </p>
              </div>
            )}

            <div className="pb-10 pt-6 sm:pt-20">
              <Button.Primary
                className="text-left text-white rounded-md w-full sm:w-[333px] flex justify-center mx-auto "
                onClick={openModal}
                title={"Add New Card"}
              />
            </div>

            {/* <Button.Secondary
              type="button"
              title={"Back"}
              className={"sm:hidden rounded-md mb-8 sm:mb-0 w-full"}
              onClick={() => navigate("/profile")}
            /> */}
          </div>
          <DeleteCardModal
            show={deleteModalVisible}
            onClose={closeDeleteModal}
            id={selectedCardId}
          />
        </div>
      </>
    );
}
